import React from 'react'

import PageContent from "../components/content/page-content"
import {PageContentInterface} from "../components/page-content-interface"
import DocumentPage from "../../../../core/model2/doc/pages/page"
import PageCover from "../components/cover/cover"
import AttachmentsCollection from "../../../../core/model2/attachment/attachments"

// const debug: string = "PageExportContainer"
const debug: boolean = false

type Props = {
    app: PageContentInterface,
}

export default class PageExportContainer extends React.Component<Props, any> {
    render() {
        debug && console.log(debug, "render", this.props.app.document)

        const page = this.props.app.document.pages.getPage(this.props.app.currentPageId)!
        const attachmentsCollection: AttachmentsCollection = page.attachmentsCollection // there is only one page so get attachments from the first one

        const hasCover = this.props.app.document?.cover

        const classes = Classes('project-page-main', {
            'is-full-width' : this.props.app.settings?.isFullWidth,
            'with-cover'    : hasCover
        })



        // Wears .project-page the way DocumentExportContainer wears .app-doc-view: every layout
        // rule in project-page.scss is nested under it - the editor is only constrained to its
        // 740px + padding there - and the exported HTML is wrapped in it too. Measured outside it
        // the content laid out full width, so the height handed to the PDF service was far short
        // of what it then rendered and the last pages were cut off.
        // .page-export-container then overrides the flex layout below with plain blocks, which is
        // what makes the per-page breaks work.
        return (
            <div className="project-page page-export-container">
                <div className={classes}>
                    <PageCover app          = {this.props.app}
                               isFullWidth  = {true}
                               attachments  = {attachmentsCollection}/>

                    <div className="main-content flex-row-left-top w-100-percent">
                        <div className="flex-column-left-top flex-1 p-l-60 p-r-30">
                            {_.map(this.props.app.document.pages.models, (page: DocumentPage)=> {
                                return (
                                    // one document page per PDF page - the break itself is
                                    // .page-export-page in project-page.scss
                                    <div key={page.id} className="page-export-page">
                                        <PageContent app            = {this.props.app}
                                                     pageId         = {page.id}
                                                     isPDFVersion   = {true}/>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
